import * as THREE from "three"
import Experience from "../Experience"

export default class Environment
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug

        // Debug
        if(this.debug.active)
        {
            this.debugFolderGeneral = this.debug.ui.addFolder('Environment')

            this.debugFolderDirLight1 = this.debugFolderGeneral.addFolder('Direct. Light 1')
            this.debugFolderDirLight2 = this.debugFolderGeneral.addFolder('Direct. Light 2')
            this.debugFolderDirLight3 = this.debugFolderGeneral.addFolder('Direct. Light 3')

            this.debugFolderAmbLight = this.debugFolderGeneral.addFolder('Ambient Light')
        }

        this.setAmbLights()
        this.setDirLights()

        console.log()
    }

    setAmbLights()
    {
        this.ambientLight = new THREE.AmbientLight('#ffffff', 0.08)
        this.scene.add(this.ambientLight)

        // Debug
        if(this.debug.active)
        {
            this.debugFolderAmbLight
                .add(this.ambientLight, 'intensity')
                .min(0)
                .max(1)
        }
    }

    setDirLights()
    {
        // Direct Light 1
        this.dirLight1 = new THREE.DirectionalLight('#ffffff', 2.7)
        this.dirLight1.castShadow = true
        this.dirLight1.shadow.camera.far = 15
        this.dirLight1.shadow.mapSize.set(1024, 1024)
        this.dirLight1.shadow.normalBias = 0.05
        this.dirLight1.position.set(5, 1.2, - 1.25)
        this.scene.add(this.dirLight1)
        // this.scene.add(new THREE.DirectionalLightHelper(this.dirLight1))
        
        // Direct Light 2
        this.dirLight2 = new THREE.DirectionalLight('#ffffff', 2.7)
        this.dirLight2.castShadow = true
        this.dirLight2.shadow.camera.far = 15
        this.dirLight2.shadow.mapSize.set(1024, 1024)
        this.dirLight2.shadow.normalBias = 0.05
        this.dirLight2.position.set(-5, 1.2, - 1.25)
        this.scene.add(this.dirLight2)
        // this.scene.add(new THREE.DirectionalLightHelper(this.dirLight2))

        // Direct Light 3
        this.dirLight3 = new THREE.DirectionalLight('#ffffff', 1.2)
        this.dirLight3.castShadow = true
        this.dirLight3.shadow.camera.far = 15
        this.dirLight3.shadow.mapSize.set(1024, 1024)
        this.dirLight3.shadow.normalBias = 0.05
        this.dirLight3.position.set(0, 5, 1.5)
        this.scene.add(this.dirLight3)
        // this.scene.add(new THREE.DirectionalLightHelper(this.dirLight3))

        // Debug
        if(this.debug.active)
        {
            // Debug Direct Light 1
            this.debugFolderDirLight1
                .add(this.dirLight1, 'intensity')
                .name('Intensity')
                .min(0)
                .max(10)
                .step(0.001)

            this.debugFolderDirLight1
                .add(this.dirLight1.position, 'x')
                .name('x')
                .min(-5)
                .max(5)
                .step(0.001)
            
            this.debugFolderDirLight1
                .add(this.dirLight1.position, 'y')
                .name('y')
                .min(-5)
                .max(5)
                .step(0.001)

            this.debugFolderDirLight1
                .add(this.dirLight1.position, 'z')
                .name('z')
                .min(-5)
                .max(5)
                .step(0.001)
            
        }
        {
            // Debug Direct Light 2
            this.debugFolderDirLight2
                .add(this.dirLight2, 'intensity')
                .name('Intensity')
                .min(0)
                .max(10)
                .step(0.001)

            this.debugFolderDirLight2
                .add(this.dirLight2.position, 'x')
                .name('x')
                .min(-5)
                .max(5)
                .step(0.001)
            
            this.debugFolderDirLight2
                .add(this.dirLight2.position, 'y')
                .name('y')
                .min(-5)
                .max(5)
                .step(0.001)

            this.debugFolderDirLight2
                .add(this.dirLight2.position, 'z')
                .name('z')
                .min(-5)
                .max(5)
                .step(0.001)
        }
        {
            // Debug Direct Light 3
            this.debugFolderDirLight3
                .add(this.dirLight3, 'intensity')
                .name('Intensity')
                .min(0)
                .max(10)
                .step(0.001)

            this.debugFolderDirLight3
                .add(this.dirLight3.position, 'x')
                .name('x')
                .min(-5)
                .max(5)
                .step(0.001)
            
            this.debugFolderDirLight3
                .add(this.dirLight2.position, 'y')
                .name('y')
                .min(-5)
                .max(5)
                .step(0.001)

            this.debugFolderDirLight3
                .add(this.dirLight3.position, 'z')
                .name('z')
                .min(-5)
                .max(5)
                .step(0.001)
        }
    }
}